/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { IntegrationParamsDto } from './IntegrationParamsDto';

export type MysqlIntegrationParamsDto = (IntegrationParamsDto & {
    database?: string;
    host?: string;
    mysqlTlsVersion?: MysqlIntegrationParamsDto.mysqlTlsVersion;
    port?: number;
    siffletAgentEnabled?: boolean;
} & {
    database: string;
    host: string;
    mysqlTlsVersion: MysqlIntegrationParamsDto.mysqlTlsVersion;
    port: number;
    siffletAgentEnabled: boolean;
});

export namespace MysqlIntegrationParamsDto {

    export enum mysqlTlsVersion {
        TLS_V_1_2 = 'TLS_V_1_2',
        TLS_V_1_3 = 'TLS_V_1_3',
    }


}
